import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/checkbox-checked.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-2 pt-3 pb-2 border-t border-gray-200"
}
const _hoisted_3 = {
  for: "report",
  class: "flex items-center gap-2 cursor-pointer"
}
const _hoisted_4 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  class: ""
}
const _hoisted_6 = { class: "w-full flex items-center justify-between pt-3 mt-[46px] border-t border-black/15" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import QuestionnaireAnswerReview from "../parts/QuestionnaireAnswerReview.vue";
import QuestionnaireButtonNext from "../parts/QuestionnaireButtonNext.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireFinalScreen from "../parts/QuestionnaireFinalScreen.vue";
import QuestionnaireTextField from "../parts/QuestionnaireTextField.vue";
import { ref } from "vue";

type Props = {
  finalTitle: string;
  finalSubtitle?: string;
  prevButtonText: string;
  nextButtonText?: string;
  doneButtonText?: string;
  textFieldTitle?: string;
  textFieldPlaceholder?: string;
  answers?: Array<{
    question: string;
    answer: string;
  }>;
  status?: string;
  isLoading: boolean;
  currentPhase: any;
};
type Emits = {
  (event: "onStepBack"): void;
  (event: "onSubmit", ibnDate: string, generateReport?: boolean): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'AbnahmeAppointmentFinal',
  props: {
    finalTitle: {},
    finalSubtitle: {},
    prevButtonText: {},
    nextButtonText: {},
    doneButtonText: {},
    textFieldTitle: {},
    textFieldPlaceholder: {},
    answers: {},
    status: {},
    isLoading: { type: Boolean },
    currentPhase: {}
  },
  emits: ["onStepBack", "onSubmit"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const ibnDate = ref("");
const ibnDateError = ref({
  isError: false,
  message: "",
});
const isSelectedCheckbox = ref();

const onSubmit = () => {
  if (props.currentPhase?.phaseId === 2 && props.textFieldTitle) {
    if (ibnDate.value && ibnDate.value.trim() !== "") {
      ibnDateError.value.isError = false;
      ibnDateError.value.message = "";
    } else {
      ibnDateError.value.isError = true;
      ibnDateError.value.message = "This field is required!";
    }
  }
  if (!ibnDateError.value.isError) {
    emits("onSubmit", ibnDate.value, isSelectedCheckbox.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(QuestionnaireFinalScreen, {
        title: __props.finalTitle,
        "sub-title": __props.finalSubtitle,
        status: __props.status
      }, null, 8, ["title", "sub-title", "status"])
    ]),
    (__props.textFieldTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(QuestionnaireTextField, {
            modelValue: ibnDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ibnDate).value = $event)),
            title: __props.textFieldTitle,
            placeholder: __props.textFieldPlaceholder,
            "is-error": ibnDateError.value.isError,
            "error-message": ibnDateError.value.message
          }, null, 8, ["modelValue", "title", "placeholder", "is-error", "error-message"]),
          (!__props.currentPhase.hasQc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "report",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isSelectedCheckbox).value = $event)),
                  class: _normalizeClass(isSelectedCheckbox.value ? 'hidden' : 'block')
                }, null, 2), [
                  [_vModelCheckbox, isSelectedCheckbox.value]
                ]),
                _createElementVNode("label", _hoisted_3, [
                  _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
                    [_vShow, isSelectedCheckbox.value]
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-base font-normal leading-5 tracking-[0.01rem] text-primary-text-color" }, " Generate report ", -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (__props.answers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(QuestionnaireAnswerReview, { answers: __props.answers }, null, 8, ["answers"])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createVNode(QuestionnaireButtonPrev, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onStepBack'))),
          "button-text": __props.prevButtonText
        }, null, 8, ["button-text"])
      ]),
      (__props.doneButtonText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(QuestionnaireButtonNext, {
              "is-loading": __props.isLoading,
              onClick: onSubmit,
              "button-text": __props.doneButtonText
            }, null, 8, ["is-loading", "button-text"])
          ]))
        : (__props.nextButtonText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(QuestionnaireButtonNext, {
                "is-loading": __props.isLoading,
                "button-text": __props.nextButtonText
              }, null, 8, ["is-loading", "button-text"])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})